export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyAWpgRQfpNisvXey6Z2ExmStB9wyrlrDZ8",
        authDomain: "scuole-poschiavo-5fs67dx6d.firebaseapp.com",
        databaseURL: "https://scuole-poschiavo-5fs67dx6d.firebaseio.com",
        projectId: "scuole-poschiavo-5fs67dx6d",
        storageBucket: "scuole-poschiavo-5fs67dx6d.appspot.com",
        messagingSenderId: "1081678937718",
        appId: "1:1081678937718:web:5beb78122fc0cb99b06957",
        measurementId: "G-6W0YZ2RPPF"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts